<ng-template #loadingTemplate>
  <lana-loading></lana-loading>
</ng-template>
<ng-container *ngIf="htmlData; else loadingTemplate">
  <div class="email-preview" [innerHtml]="htmlData"></div>
</ng-container>
